export default __webpack_public_path__ + "media/images/icons_button/btn-pdf-c93588ffb230e616a5a8b56cfa6ac841.png";